import React from "react";
import * as S from "./styles";

const CompletedBuyModal = () => {
  return (
    <S.Container>
      <S.Text>Obrigado por comprar conosco!</S.Text>

      <S.Icon className='fas fa-smile-wink' />
    </S.Container>
  );
};

export default CompletedBuyModal;
